import React from "react";

import "./Beta.scss";

export const Beta = () => {
  return <div className="Beta">Beta</div>;
};
